<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">ประวัติเติมเครดิตของสาขา</h1>
                    <p class="text-white pb-3 px-3">รายการเติมเครดิตของสาขา</p>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-lg-7">
                                    <b-form-group id="input-group-1" label="ค้นหาวันที่ทำรายการ (วันเริ่มต้น - วันสุดท้าย)" label-for="input-1" class="mb-0">
                                        <div class="row align-self-center">
                                            <div class="col-lg-5">
                                                <date-range-picker
                                                    class="w-100"
                                                    :opens="'center'"
                                                    @start-selection="logEvent('startSelection', $event)"
                                                    @finish-selection="logEvent('finishSelection', $event)"
                                                    :min-date="minDate"
                                                    :max-date="maxDate"
                                                    :singleDatePicker="false"
                                                    :appendToBody="true"
                                                    :ranges="false"
                                                    :closeOnEsc="false"
                                                    :autoApply="true"
                                                    :locale-data="{ format: 'dd-mm-yyyy' }"
                                                    v-model="filters">
                                                </date-range-picker>
                                            </div>
                                            <div class="col-lg-5">
                                                <b-form-input v-model="filter" type="text" placeholder="ค้นหาข้อมูลในตาราง"></b-form-input>
                                            </div>

                                            <div class="col-lg-2">
                                                <button class="btn btn-info btn-sm-res"
                                                    @click="historyTopUpWalletToShop()" >
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </b-form-group>
                                    <hr class="d-block d-md-none d-lg-none mb-0" />
                                </div>
                                <div class="col-lg-3">
                                    <b-form-group id="input-group-1" label="ตัวกรอง" label-for="input-1" class="mb-0">
                                        <select class="form-control" v-model="filterChannel">
                                            <option :value="channel.key" v-for="channel in dataChannel" :key="channel.key">{{channel.title}}</option>
                                        </select>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-2">
                                    <b-form-group label="Export File" class="mb-0 pb-2">
                                        <div class="btn-group btn-sm-res btn-export" role="group" aria-label="Basic example">
                                            <ExportExcel
                                                :columns="columnsExcel"
                                                :getData="getDataBranceExportExcel"
                                                name="ประวัติเติมเงินสาขา "
                                            >
                                            </ExportExcel>
                                            <b-button variant="info btn-sm-res" @click="$htmlToPaper('tablePrint')">print</b-button>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                        <div id="tablePrint">
                            <b-table
                                show-empty
                                responsive
                                :items="data"
                                :fields="fields"
                                :filter="filter"
                                :busy="busy"
                                class="scroll-bar-pop"
                                foot-clone
                                >
                                <div slot="table-busy" class="text-center">
                                    <BlockUI>
                                        <div class="loader"></div>
                                    </BlockUI>
                                </div>
                                <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
                                <template slot="created_at" slot-scope="row">{{ row.item.created_at | dateFormat(main_use_walletV2) }}</template>
                                <template slot="subject" slot-scope="row">
                                    <span>
                                        {{statusPaymentSubject(row.item.subject).text}}
                                    </span>
                                </template>
                                <template slot="credit" slot-scope="row">
                                    {{ row.item.credit | numFormat('0,0.00') }}
                                </template>
                                <template slot="status" slot-scope="row">
                                    <b-badge :variant="statusPayment(row.item.status).color +' report'" >
                                        {{statusPayment(row.item.status).status}}
                                    </b-badge>
                                </template>
                                <template slot="ref_no2" slot-scope="row">
                                    <span>
                                        {{statusPaymentChannel(row.item.ref_no2).text}}
                                    </span>
                                </template>
                                <template slot="FOOT_index">รวม</template>
                                <template slot="FOOT_created_at">&nbsp;</template>
                                <template slot="FOOT_transaction_id">&nbsp;</template>
                                <template slot="FOOT_shop_code">&nbsp;</template>
                                <template slot="FOOT_shop_name">&nbsp;</template>
                                <template slot="FOOT_shop_owner_name">&nbsp;</template>
                                <template slot="FOOT_subject">&nbsp;</template>
                                <template slot="FOOT_credit">
                                    {{footerTotal.credit | numFormat('0,0.00')}}
                                </template>
                                <template slot="FOOT_status">&nbsp;</template>
                                <template slot="FOOT_ref_no2">&nbsp;</template>
                                <template slot="FOOT_remark">&nbsp;</template>
                            </b-table>
                            <div class="mt-3">
                                <b-pagination
                                    :total-rows="dataLength"
                                    :current-page="pagination.currentPage"
                                    :per-page="pagination.perPage"
                                    :value="pagination.currentPage"
                                    @input="changePage"
                                    align="right" >
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import ExportExcel from '@/components/custom/exportExcel/ExportExcel'
import { statusPaymentSubject , statusPayment , statusPaymentChannel } from "@/axios/walletPayment.js"
import { dateLimitRanges } from "@/plugins/datePicker.js"

export default {
    name: "historytopupwallettoshop",
    components:{
        ExportExcel
    },
    data() {
        return {
            busy: false,
            data: [],
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            filters: {
                excelDate: "",
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
            },
            filter: null,
            filterChannel: 'DEPOSIT_PGW',
            dataChannel:[
                { key: 'DEPOSIT_PGW' , title: 'เติมเงินโดยร้านค้า' },
                { key: 'DEPOSIT_INSTANT' , title: 'เติมเงินโดยผู้ดูแลระบบ' },
            ],
            pagination:{
                currentPage: 1,
                perPage: 1,
                totalPage: 1
            },
            statusPaymentSubject: statusPaymentSubject,
            statusPayment: statusPayment,
            statusPaymentChannel: statusPaymentChannel
        }
    },
    filters: {
        dateFormat(date, use_walletV2) {
            if (use_walletV2) {
                // UTC to +07:00
                return moment(date, "YYYY-MM-DD HH:mm:ss")
                    .add(7, 'hours')
                    .format("DD/MM/YYYY HH:mm:ss");
            }

            return moment(date, "YYYY-MM-DD HH:mm:ss")
                .format("DD/MM/YYYY HH:mm:ss");
        },
    },
    mounted() {
        this.historyTopUpWalletToShop()
    },
    methods: {
        logEvent( event , date ){
            const { minDate , maxDate } =  dateLimitRanges(event, date);
            this.minDate = minDate
            this.maxDate = maxDate
        },
        changePage(i){
            if (this.pagination.currentPage == i) return
            this.pagination.currentPage = i
            this.historyTopUpWalletToShop()
        },
        async historyTopUpWalletToShop(){
            this.busy = true
            let dateStart = moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss")
            let dateEnd = moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")
            await this.$http
                .get(

                    this.$API_URL + "/wallet/agent/transaction/info",{
                        headers: {
                            Token: localStorage.getItem("access_token")
                        },
                        params: {
                            date_start: dateStart,
                            date_end: dateEnd,
                            subject: 'deposit',
                            filter: { payment_method: this.filterChannel },
                            page: this.pagination.currentPage
                        }
                    }
                )
                .then(res => {
                    let result = res.data
                    if( result.status ){
                        this.data = result.data.data
                        this.pagination.perPage = result.data.per_page
                        this.pagination.currentPage = result.data.page
                        this.pagination.totalPage = result.data.total_page
                    }
                    this.busy = false
                })
        },
        async getDataBranceExportExcel() {
            return new Promise( resolve => {
                let ExcelTask = []
                let page = 1;
                for( let i = 0 ; i < this.pagination.totalPage; i++ ){
                    ExcelTask.push( this.$http
                        .get(
                            this.$API_URL + "/wallet/agent/transaction/info",{
                                headers: {
                                    Token: localStorage.getItem("access_token")
                                },
                                params: {
                                    date_start: moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss"),
                                    date_end: moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss"),
                                    subject: 'deposit',
                                    filter: { payment_method: this.filterChannel },
                                    page: page++
                                }
                            }
                        )
                    )
                }
                Promise.all(ExcelTask).then( (resData) => {
                    let dataExcel = [];
                    resData.forEach( data => {
                        dataExcel.push(...data.data.data.data)
                    })
                    resolve(dataExcel)
                })
            })
        },
    },
    computed: {
        dataLength(){
            return Number(this.pagination.totalPage) *  Number(this.pagination.perPage)
        },
        fields(){
            let fields = [
                { key: "index", field: "index", label: "ลำดับ", sortable: true },
                { key: "created_at", field: "created_at", label: "วันเวลาที่ทำรายการ", sortable: true , class:"text-center" },
                { key: "transaction_id", field: "transaction_id", label: "หมายเลขรายการ", sortable: true , class:"text-center" },
                { key: "shop_code", field: "shop_code", label: "รหัสร้าน", sortable: true },
                { key: "shop_name", field: "shop_name", label: "ชื่อร้านค้า", sortable: true },
                { key: "shop_owner_name", field: "shop_owner_name", label: "ชื่อเจ้าของร้าน", sortable: true },
                { key: "subject", field: "subject", label: "ประเภทรายการ", sortable: true },
                { key: "credit", field: "credit", label: "จำนวนเครดิต (บาท)", sortable: true },
                { key: "status", field: "status", label: "สถานะรายการ", sortable: true },
                { key: "ref_no2", field: "ref_no2", label: "ช่องทาง", sortable: true },
                { key: "remark", field: "remark", label: "หมายเหตุ", sortable: true }

            ]
            return fields
        },
        columnsExcel(){
            let columns =  [
                { field: "created_at", label: "วันเวลาที่ทำรายการ"  },
                { field: "transaction_id", label: "หมายเลขรายการ"  },
                { field: "shop_code", label: "รหัสร้าน" },
                { field: "shop_name", label: "ชื่อร้านค้า" },
                { field: "shop_owner_name", label: "ชื่อเจ้าของร้าน" },
                {
                    field: "subject",
                    label: "ประเภทรายการ",
                    dataFormat: value => {
                        return statusPaymentSubject( value ).text;
                    }
                },
                {
                    field: "credit",
                    label: "จำนวนเครดิต (บาท)",
                    dataFormat: value => {
                        return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                    }
                },
                {
                    field: "status",
                    label: "สถานะรายการ",
                    dataFormat: value => {
                        return statusPayment( value ).status;
                    }
                },
                {
                    field: "ref_no2",
                    label: "ช่องทาง",
                    dataFormat: value => {
                        return statusPaymentChannel( value ).text;
                    }
                },
                { field: "remark", label: "หมายเหตุ" }
            ]
            return columns
        },
        footerTotal(){
            let total = { credit: 0 }
            this.data.forEach( item => {total.credit += +item.credit} )
            return total
        }
    }
};
</script>
